import generateMethodKey from '../../lib/generateMethodKey';
import { store } from '../../store';

export const isNotShipped = ({ label }) =>
  Boolean(
    label.tracking_status === 'NotShipped' ||
      label.tracking_status === 'null' ||
      label.tracking_status == null,
  );

export const getInitiatedReturnsHeader = ({ label }) => {
  const { language } = store.getState();
  const methodKey = generateMethodKey(label);
  const {
    'returns.step_1.initiated_returns_header': defaultInitiatedHeader,
    [`returns.step_1.initiated_returns_header.${methodKey}`]: methodBasedInitiatedHeader,
    'returns.step_1.scanned_returns_header': scannedHeader,
  } = language;
  const initiatedHeader = methodBasedInitiatedHeader || defaultInitiatedHeader;
  return isNotShipped({ label }) ? initiatedHeader : scannedHeader;
};
